// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.RentalManagerUserPropertyCreateWebApiHandler

import { frontEndRequestV2 } from '@zg-rentals/ts-client-fetch';
import type { RentalManagerEnvironment } from '@zg-rentals/rental-manager-env-base';

import type { ListingType, PropertyType, UserPropertyCreateResponseWebDto } from '../..';

interface CreateParams {
  customerId?: string;
  fullAddress: string;
  includeWebAnalytics?: boolean;
  listingType: ListingType;
  numUnits?: number;
  propertyType: PropertyType;
  unitNumber?: string;
}
interface CreateForSelfServeOnboardingParams {
  accountZrnNumber: string;
  fullAddress: string;
  listingType: ListingType;
  propertyType: PropertyType;
}

export const RentalManagerUserPropertyCreateWebApiHandler_create_Path = '/api/web/v1/users/properties/create';

/**
 * Create a property for the user
 */
export const RentalManagerUserPropertyCreateWebApiHandler_create = (
  getParams: CreateParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<CreateParams, never, UserPropertyCreateResponseWebDto>({
    getParams: getParams,
    endpoint: RentalManagerUserPropertyCreateWebApiHandler_create_Path,
    method: 'POST',
    contextPath: '/rental-manager-api',
    environment,
  });
};

export const RentalManagerUserPropertyCreateWebApiHandler_createForSelfServeOnboarding_Path =
  '/api/web/v1/users/properties/createForSelfServeOnboarding';

/**
 * Create a property for the user for self serve onboarding
 */
export const RentalManagerUserPropertyCreateWebApiHandler_createForSelfServeOnboarding = (
  getParams: CreateForSelfServeOnboardingParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<CreateForSelfServeOnboardingParams, never, string>({
    getParams: getParams,
    endpoint: RentalManagerUserPropertyCreateWebApiHandler_createForSelfServeOnboarding_Path,
    method: 'POST',
    contextPath: '/rental-manager-api',
    environment,
  });
};
